import React, { useState, useEffect } from 'react';
import { serverHost } from "../src/config";
import * as Utils from "../src/utils";

import Document from "./Document";
import DocumentFilterSelector from "./DocumentFilterSelector";


function DocumentsList(props) {
    useEffect(() => {
        setAllDocuments([]);
    }, []);

    const [allDocuments, setAllDocuments] = useState([]);

    const [selectedFilter, setSelectedFilter] = useState('sign_date_asc');

    const updateList = () => {
        if (props.userMail != null) {
            let params = new URLSearchParams({
                orderBy: selectedFilter
            });

            let url = serverHost + "/documents/getDocumentsByUserMail?" + params;
            Utils.jsonGet(url)
                .then((json) =>
                    setAllDocuments(json.documents)
                )
                .catch((error) => {
                    console.log(error);
                });
        } else {
            setAllDocuments([])
        }
    }

    useEffect(() => {
        updateList();
    },[selectedFilter])

    const docList = (
        <div>
            <div className = "mt-3 mb-1">
                Kārtot pēc: 
                <DocumentFilterSelector 
                    selectedFilter = {selectedFilter}
                    setSelectedFilter = {setSelectedFilter}
                />
            </div>
            <div className="container table mt-3 p-0">               
                <div className = "row border-bottom p-1 d-none d-lg-flex d-xl-flex">
                    <div className = "col-sm">
                        <b>Pievienošanas datums</b>
                    </div>
                    <div className = "col-sm">
                        <b>Dokumenta datums</b>
                    </div>
                    <div className = "col-sm">
                        <b>Nosaukums</b>
                    </div>
                    <div className = "col-sm">
                        <b>Numurs</b>
                    </div>
                    <div className = "col-sm">
                        <b>Parakstīts</b>
                    </div>
                    <div className = "col-sm">
                        <b>Atvērt</b>
                    </div>
                </div>
                {allDocuments.map((item, i) => (
                    <Document
                        key={item.documentId}
                        document={item}
                        userMail={props.userMail}
                        orderNumber={i}
                    />
                ))}
            </div>
        </div>
    );
    return (docList);
}

export default DocumentsList;